import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { BehaviorSubject, Subject } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { AchievementDetailDTO } from "src/app/data/schema/Gamification/AchievementDetail/AchievementDetailDTO";
import { RankingDTO } from "src/app/data/schema/Gamification/Ranking/RankingDTO";
import { ApiAchievementDetailsService } from "src/app/data/service/gamification/api-achievement-details.service";
import { ApiRankingService } from "src/app/data/service/gamification/api-ranking.service";

@Component({
    selector: "app-profile-achievements",
    templateUrl: "./profile-achievements.component.html",
    styleUrls: ["./profile-achievements.component.scss"]
})
export class ProfileAchievementsComponent implements OnInit, OnDestroy {
    public search$ = new BehaviorSubject<string>("");
    public isLoading: boolean;

    achievements: AchievementDetailDTO[] = [];
    totalRows: number;
    rankings: RankingDTO[];
    selectedRanking: RankingDTO;
    pageNumber = 0;

    private _unSubscribeAll = new Subject();
    constructor(
        private authService: AuthService,
        private achievementDetailService: ApiAchievementDetailsService,
        private rankingsService: ApiRankingService,
        private spinner: NgxSpinnerService
    ) {}

    ngOnDestroy(): void {
        this._unSubscribeAll.unsubscribe();
    }

    loadRankings(): void {
        this.spinner.show();

        this.rankingsService
            .list({ find: "", orderBy: "name", sortOrder: "asc", skip: 0, take: 100, active: true, valids: true })
            .subscribe(
                (res) => {
                    if (res.data.length == 0) return;

                    this.rankings = res.data;
                    this.spinner.hide();
                },
                () => {
                    this.spinner.hide();
                }
            );
    }

    ngOnInit() {
        this.loadRankings();
    }

    loadAchievements(): void {
        if (!this.selectedRanking) return;

        this.isLoading = true;
        this.achievementDetailService
            .list({
                find: "",
                orderBy: "updatedat",
                sortOrder: "desc",
                skip: this.pageNumber * 10,
                take: 10,
                userIds: [this.authService.getClaimsUserId()],
                rankingId: this.selectedRanking.id
            })
            .subscribe((res) => {
                this.totalRows = res.totalRows;
                this.achievements.push(...res.data);
                this.isLoading = false;
            });
    }

    changeSelectedRanking(i: number): void {
        this.selectedRanking = this.rankings[i];
        this.achievements = [];
        this.pageNumber = 0;
        this.loadAchievements();
    }

    loadMore(): void {
        ++this.pageNumber;
        this.loadAchievements();
    }
}
